import * as React from "react"

function Logo(props) {
  const logoBlack = "/ArtWorks_black.svg";
  const logoWhite = "/ArtWorks_white.svg";
  const logo = props.version === "black" ? logoBlack : logoWhite;
  return (
    <img  src={logo} alt="Art Works" width="210px" height="140px"  />
  )
}

export default Logo